/**
 * CMCD response mode variable name.
 *
 * @group CMCD
 *
 * @beta
 */
export const CMCD_RESPONSE_MODE = 'response';
//# sourceMappingURL=CMCD_RESPONSE_MODE.js.map